import React from "react";

/** Ячейка «Проведён» — Да / Нет */
export const ConductedCellRenderer = (params) => {
  const value = params.data?.isConducted;
  if (value === -1 || value === undefined) return null;
  return value ? "Да" : "Нет";
};
